import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/reportes/reporteGeneralIgss';

import GeneralReportIgss from './GeneralReportIgss';
import {resetStore} from "../../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.general_report_form,
        usuario: state.login.me,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(GeneralReportIgss);
